import { Provider } from "@redotech/redo-model/order";
import * as z from "zod/v4";

export const getTeamProviders = {
  name: "getTeamProviders" as const,
  input: z.object({}),
  output: z.object({
    default: z.enum(Provider),
    available: z.array(z.enum(Provider)),
  }),
};
